"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var animationData = {
    v: '5.7.1',
    fr: 29.9700012207031,
    ip: 0,
    op: 60.0000024438501,
    w: 80,
    h: 80,
    nm: 'Logo-Animation-Rounded',
    ddd: 0,
    assets: [
        {
            id: 'comp_0',
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: 'Logo-Shape-2',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [180, 180, 0], ix: 2 },
                        a: { a: 0, k: [50.5, 50, 0], ix: 1 },
                        s: { a: 0, k: [220.851, 220.851, 100], ix: 6 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [-0.001, -8.102],
                                                [0.333, -15.605],
                                                [9.661, 10.055],
                                                [-8.064, 0],
                                                [0, 0],
                                                [8.469, 8.089],
                                            ],
                                            o: [
                                                [0.002, 18.051],
                                                [-0.201, 9.447],
                                                [-8.374, -8.715],
                                                [0, 0],
                                                [8.345, 0],
                                                [-12.467, -11.91],
                                            ],
                                            v: [
                                                [-0.909, -39.87],
                                                [-0.608, 38.525],
                                                [-30.783, 29.024],
                                                [-40.097, -0.679],
                                                [39.816, -0.679],
                                                [30.511, -30.751],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'tm',
                                    s: {
                                        a: 1,
                                        k: [
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [0] },
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 20, s: [0] },
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 40, s: [0] },
                                            { t: 60.0000024438501, s: [100] },
                                        ],
                                        ix: 1,
                                        x: "var $bm_rt;\n$bm_rt = content('Group 1').content('Trim Paths 1').start;",
                                    },
                                    e: {
                                        a: 1,
                                        k: [
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [0] },
                                            { i: { x: [0.719], y: [0.617] }, o: { x: [0.333], y: [0] }, t: 20, s: [0] },
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.525], y: [0.853] }, t: 40, s: [50] },
                                            { t: 60.0000024438501, s: [100] },
                                        ],
                                        ix: 2,
                                    },
                                    o: { a: 0, k: 0, ix: 3 },
                                    m: 1,
                                    ix: 2,
                                    nm: 'Trim Paths 1',
                                    mn: 'ADBE Vector Filter - Trim',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 12, ix: 5 },
                                    lc: 2,
                                    lj: 1,
                                    ml: 10,
                                    bm: 0,
                                    nm: 'Stroke 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [49.991, 50.674], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: {
                                        a: 1,
                                        k: [
                                            {
                                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                                t: 0,
                                                s: [100, 100],
                                            },
                                            {
                                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                                t: 15,
                                                s: [100, 100],
                                            },
                                            {
                                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                                t: 30,
                                                s: [100, 100],
                                            },
                                            {
                                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                                t: 45,
                                                s: [100, 100],
                                            },
                                            { t: 60.0000024438501, s: [100, 100] },
                                        ],
                                        ix: 3,
                                    },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: {
                                        a: 1,
                                        k: [
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 15, s: [100] },
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [100] },
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 45, s: [100] },
                                            { t: 60.0000024438501, s: [100] },
                                        ],
                                        ix: 7,
                                    },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Group 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 0,
                    op: 90.0000036657751,
                    st: 0,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 2,
                    ty: 4,
                    nm: 'Logo-Shape-1',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [180, 180, 0], ix: 2 },
                        a: { a: 0, k: [50.5, 50, 0], ix: 1 },
                        s: { a: 0, k: [220.851, 220.851, 100], ix: 6 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [-0.001, -8.102],
                                                [0.333, -15.605],
                                                [9.661, 10.055],
                                                [-8.064, 0],
                                                [0, 0],
                                                [8.469, 8.089],
                                            ],
                                            o: [
                                                [0.002, 18.051],
                                                [-0.201, 9.447],
                                                [-8.374, -8.715],
                                                [0, 0],
                                                [8.345, 0],
                                                [-12.467, -11.91],
                                            ],
                                            v: [
                                                [-0.909, -39.87],
                                                [-0.608, 38.525],
                                                [-30.783, 29.024],
                                                [-40.097, -0.679],
                                                [39.816, -0.679],
                                                [30.511, -30.751],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'tm',
                                    s: {
                                        a: 1,
                                        k: [
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [0] },
                                            { t: 20.0000008146167, s: [100] },
                                        ],
                                        ix: 1,
                                        x: "var $bm_rt;\n$bm_rt = content('Group 1').content('Trim Paths 1').start;",
                                    },
                                    e: {
                                        a: 1,
                                        k: [
                                            { i: { x: [0.706], y: [0.323] }, o: { x: [0.333], y: [0] }, t: 0, s: [0] },
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.295], y: [0.214] }, t: 20, s: [25] },
                                            { t: 40.0000016292334, s: [100] },
                                        ],
                                        ix: 2,
                                    },
                                    o: { a: 0, k: 0, ix: 3 },
                                    m: 1,
                                    ix: 2,
                                    nm: 'Trim Paths 1',
                                    mn: 'ADBE Vector Filter - Trim',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 12, ix: 5 },
                                    lc: 2,
                                    lj: 1,
                                    ml: 10,
                                    bm: 0,
                                    nm: 'Stroke 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [49.991, 50.674], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: {
                                        a: 1,
                                        k: [
                                            {
                                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                                t: 0,
                                                s: [100, 100],
                                            },
                                            {
                                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                                t: 15,
                                                s: [100, 100],
                                            },
                                            {
                                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                                t: 30,
                                                s: [100, 100],
                                            },
                                            {
                                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                                t: 45,
                                                s: [100, 100],
                                            },
                                            { t: 60.0000024438501, s: [100, 100] },
                                        ],
                                        ix: 3,
                                    },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: {
                                        a: 1,
                                        k: [
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 15, s: [100] },
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [100] },
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 45, s: [100] },
                                            { t: 60.0000024438501, s: [100] },
                                        ],
                                        ix: 7,
                                    },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Group 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 0,
                    op: 90.0000036657751,
                    st: 0,
                    bm: 0,
                },
            ],
        },
    ],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 0,
            nm: 'Logo',
            refId: 'comp_0',
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [40, 40, 0], ix: 2 },
                a: { a: 0, k: [180, 180, 0], ix: 1 },
                s: { a: 0, k: [21.111, 21.111, 100], ix: 6 },
            },
            ao: 0,
            w: 360,
            h: 360,
            ip: 0,
            op: 60.0000024438501,
            st: 0,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: 'Circle-Base',
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [40, 40, 0], ix: 2 },
                a: { a: 0, k: [0, 0, 0], ix: 1 },
                s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            ef: [
                {
                    ty: 25,
                    nm: 'Drop Shadow',
                    np: 8,
                    mn: 'ADBE Drop Shadow',
                    ix: 1,
                    en: 1,
                    ef: [
                        {
                            ty: 2,
                            nm: 'Shadow Color',
                            mn: 'ADBE Drop Shadow-0001',
                            ix: 1,
                            v: { a: 0, k: [0, 0, 0, 1], ix: 1 },
                        },
                        { ty: 0, nm: 'Opacity', mn: 'ADBE Drop Shadow-0002', ix: 2, v: { a: 0, k: 0, ix: 2 } },
                        { ty: 0, nm: 'Direction', mn: 'ADBE Drop Shadow-0003', ix: 3, v: { a: 0, k: 135, ix: 3 } },
                        { ty: 0, nm: 'Distance', mn: 'ADBE Drop Shadow-0004', ix: 4, v: { a: 0, k: 8, ix: 4 } },
                        { ty: 0, nm: 'Softness', mn: 'ADBE Drop Shadow-0005', ix: 5, v: { a: 0, k: 16, ix: 5 } },
                        { ty: 7, nm: 'Shadow Only', mn: 'ADBE Drop Shadow-0006', ix: 6, v: { a: 0, k: 0, ix: 6 } },
                    ],
                },
            ],
            shapes: [
                {
                    ty: 'gr',
                    it: [
                        {
                            d: 1,
                            ty: 'el',
                            s: { a: 0, k: [69.959, 69.959], ix: 2 },
                            p: { a: 0, k: [0, 0], ix: 3 },
                            nm: 'Ellipse Path 1',
                            mn: 'ADBE Vector Shape - Ellipse',
                            hd: false,
                        },
                        {
                            ty: 'st',
                            c: { a: 0, k: [0.513725968903, 0.901961023667, 0.913725968903, 1], ix: 3 },
                            o: { a: 0, k: 100, ix: 4 },
                            w: { a: 0, k: 0, ix: 5 },
                            lc: 1,
                            lj: 1,
                            ml: 4,
                            bm: 0,
                            nm: 'Stroke 1',
                            mn: 'ADBE Vector Graphic - Stroke',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: { a: 0, k: [0.105882354081, 0.403921574354, 0.815686285496, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: 'Fill 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: { a: 0, k: [-0.22, 0.092], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [112.001, 112.001], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: 'Transform',
                        },
                    ],
                    nm: 'Ellipse 1',
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
            ],
            ip: 0,
            op: 60.0000024438501,
            st: 0,
            bm: 0,
        },
    ],
    markers: [],
};
exports.default = animationData;
